import { LandingNav, Footer } from './LandingPage';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="privacy-page">
      <LandingNav />
      <div className="pt-24 pb-16 px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight mb-2">Privacy Policy</h1>
          <p className="text-sm text-muted-foreground mb-10">Last updated: February 2026</p>

          <div className="space-y-8 text-sm text-muted-foreground leading-relaxed">
            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground mb-3">1. Information We Collect</h2>
              <p>We collect information you provide directly when you create an account, including your name, email address, profile picture, and organization details. We also collect usage data such as pages visited, features used, and interaction patterns to improve your experience on Slate.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground mb-3">2. How We Use Your Information</h2>
              <p>Your information is used to provide, maintain, and improve Slate's services. This includes personalizing your experience, powering AI features like Specter and Introw matchmaking, communicating service updates, and ensuring platform security. We do not sell your personal data to third parties.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground mb-3">3. Data Storage & Security</h2>
              <p>Your data is stored securely using industry-standard encryption. Project files, communications, and personal information are protected with AES-256 encryption at rest and TLS 1.3 in transit. We conduct regular security audits and maintain strict access controls.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground mb-3">4. AINAA Trust Integration</h2>
              <p>When you connect with collaborators through Slate's AINAA network, your trust score and professional credentials may be shared with potential collaborators. You control what information is visible on your profile and can adjust visibility settings at any time.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground mb-3">5. AI & Specter</h2>
              <p>Specter AI processes your project data to provide contextual insights, budget recommendations, and workflow suggestions. Your conversations with Specter are not used to train AI models. Project-specific data processed by Specter is handled within your workspace scope only.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground mb-3">6. Third-Party Services</h2>
              <p>Slate integrates with third-party services for authentication (Google OAuth), payment processing, and analytics. Each service operates under its own privacy policy. We share only the minimum information necessary for these integrations to function.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground mb-3">7. Your Rights</h2>
              <p>You have the right to access, correct, or delete your personal data at any time. You can export your project data, revoke third-party access, and close your account. To exercise these rights, visit Settings or contact our support team.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground mb-3">8. Contact</h2>
              <p>For privacy-related inquiries, reach out to us at <span className="text-foreground font-medium">privacy@slate.app</span>.</p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
